import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { CampaignEventStatus } from '@brightside-web/shared/display'
import { Campaign } from '@brightside-web/desktop/data-access/shared';
import { BsChatService } from 'libs/desktop/data-access/core-services/src/lib/Chat/bs-chat.service';
import { routePath } from 'libs/desktop/data-access/core-services/src/lib/Routing/routing.functions';
import { DisplayCampaignEvent } from 'libs/shared/display/src/lib/display-campaign/display-campaign.component';

@Component({
    selector: 'brightside-web-my-spending-info-view',
    templateUrl: './my-spending-info-view.component.html',
    styleUrls: ['./my-spending-info-view.component.scss'],
    standalone: false
})
export class MySpendingInfoViewComponent {
  campaign: Campaign = {
    key: 'my-spending-info',
    titleKey: 'MY_SPENDING_INFO_TITLE',
    image: 'my_spend_info_view',
    textBodyKey: 'MY_SPENDING_INFO_DESC',
    textBodyAlign: 'left',
    textBodyNoWrap: true,
    ctaKey: 'MESSAGE_FA',
    secondaryCtaPath: '',
    secondaryCta: '',
    ctaPath: '',
    listSubHeader: 'HOW_IT_WORKS',
    listItems: ['MY_SPENDING_INFO_MARK1', 'MY_SPENDING_INFO_MARK2', 'MY_SPENDING_INFO_MARK3'],
    alignContentToCenter: false,
  };

  private _router: Router = inject(Router);
  private _bsChatService: BsChatService = inject(BsChatService);

  handleCampaignEvent($event: DisplayCampaignEvent) {
    if ($event.type === CampaignEventStatus.FAILED) {
      this._router.navigate([routePath('home')]);
    } else {
      this._bsChatService.showChat();
    }
  }
}
